import { defineStore } from 'pinia';
import axios from 'axios';

const MIN_INTERVAL_MS = 60 * 1000;

// Avisos do admin ao lojista: o popup (NoticeGate) e a faixa (NoticeBanner) leem a mesma fila.
// A busca usa axios direto: o cache de 5 s do ApiService devolveria avisos ja confirmados.
export const useNoticeStore = defineStore('noticeStore', {
  state: () => ({
    queue: [],
    fetching: false,
    lastFetch: 0,
    shownIds: {},
    hiddenForSupport: {},
  }),

  getters: {
    // O servidor ja ordena: obrigatorios primeiro, depois o mais antigo
    modal: (state) => state.queue.find((n) => n.display !== 'banner' && !state.hiddenForSupport[n.id]) || null,
    banners: (state) => state.queue.filter((n) => n.display === 'banner' && !state.hiddenForSupport[n.id]),
    // Acesso de suporte (aberto pelo admin) so le: nao confirma nada
    readOnly: () => {
      try {
        return !!JSON.parse(localStorage.getItem('data') || 'null')?.impersonation;
      } catch (e) {
        return false;
      }
    },
  },

  actions: {
    async fetchPending(force = false) {
      if (this.fetching) return;
      if (!force && Date.now() - this.lastFetch < MIN_INTERVAL_MS) return;
      this.fetching = true;
      try {
        const { data } = await axios.get('/core/notices/pending');
        this.queue = Array.isArray(data?.data) ? data.data : [];
        this.lastFetch = Date.now();
      } catch (e) {
        // Falha de rede/sessao: nao trava a navegacao; tenta de novo na proxima rota
      } finally {
        this.fetching = false;
      }
    },

    async markShown(id) {
      if (this.shownIds[id] || this.readOnly) return;
      this.shownIds[id] = true;
      try {
        await axios.post(`/core/notices/${id}/shown`, {});
      } catch (e) {
        this.shownIds[id] = false;
      }
    },

    // Confirma a leitura. Devolve { ok } ou { error }; aviso cancelado/expirado (404) some sem erro.
    async ack(id) {
      if (this.readOnly) return { error: 'readonly' };
      try {
        await axios.post(`/core/notices/${id}/ack`, {});
      } catch (e) {
        if (e.response?.status !== 404) return { error: 'ack' };
      }
      this.queue = this.queue.filter((n) => n.id !== id);
      this.fetchPending(true);
      return { ok: true };
    },

    hideForSupport(id) {
      this.hiddenForSupport = { ...this.hiddenForSupport, [id]: true };
    },
  },
});
